import firebase from 'firebase/app'
import { getVal } from 'react-redux-firebase'
import { showToggle, hideToggle } from './toggles'
import { selectQueueIndex } from './queue'
import { setPlacementMode } from './boards'
import { firebaseAction } from '../utils'
import { cols } from 'variables'
import { push } from 'react-router-redux'
import ReactGA from 'react-ga'

// TODO: Delete file from storage
// TODO: DRY this file

import {
  PLACE_BLOCK,
  // CREATE_BLOCK,
  // DELETE_BLOCKS,
  SET_BLOCK_PROPERTIES,
  SEND_TO_FRONT,
  SEND_TO_BACK,
  GROUP,
  UNGROUP,
  QUEUE_BLOCKS,
  SELECT_BLOCKS
} from '../actionTypes'
import {
  currentBoardIdSelector,
  currentBoardSelector
} from '../selectors/selectors'
import {
  sizeSelector,
  sectionLayoutSelector,
  colWidthSelector,
  boardFullSelector
} from '../selectors/boardSelectors'
import Rectangle from '../../utils/Rectangle'
import i18n from 'i18n'
import { userIdSelector } from '../selectors/baseSelectors'
import { showAlert } from './alerts'
import { setMode } from './app'
import { setSectionMinHeight } from './sections'

const timestamp = firebase.database.ServerValue.TIMESTAMP

export const removeBlocks = blocks =>
  firebaseAction(update => {
    // dispatch({ type: DELETE_BLOCKS, payload: { blocks } })

    let forward = {}
    let backward = {}

    // exclude layout - TODO, a better way to keep DB and non-DB data seperate
    blocks.forEach(({ layout, ...block }) => {
      const path = `blocks/${block.board}/${block.id}`
      forward[path] = null
      backward[path] = block
      if (block.image && block.image.pendingUpload) {
        forward[
          `/pendingUploads/${block.image.pendingUpload}/locations/${block.id}`
        ] = null
        backward[
          `/pendingUploads/${block.image.pendingUpload}/locations/${block.id}`
        ] = path
      }
    })
    update({ forward, backward })
    ReactGA.event({
      category: 'Blocks',
      action: 'Delete Blocks',
      value: blocks.length
    })
  })

export const removeContent = blocks =>
  firebaseAction(update => {
    let forward = {}
    let backward = {}
    blocks.forEach((block, i) => {
      // add i to ensure sequence is kept
      forward[`blocks/${block.board}/${block.id}/image`] = null
      forward[`blocks/${block.board}/${block.id}/aspect`] = null
      forward[`blocks/${block.board}/${block.id}/height`] =
        block.width * block.aspect
      backward[`blocks/${block.board}/${block.id}/image`] = block.image
      backward[`blocks/${block.board}/${block.id}/aspect`] = block.aspect
      backward[`blocks/${block.board}/${block.id}/height`] = block.height
      if (block.image && block.image.pendingUpload) {
        forward[
          `/pendingUploads/${block.image.pendingUpload}/locations/${block.id}`
        ] = null
        backward[
          `/pendingUploads/${block.image.pendingUpload}/locations/${block.id}`
        ] = `blocks/${block.board}/${block.id}`
      }
    })
    update({ forward, backward })
    ReactGA.event({
      category: 'Blocks',
      action: 'Remove content'
    })
  })

// Send to front/back

const getOrderActions = (blocks, order) => {
  let forward = {}
  let backward = {}
  blocks
    .sort((a, b) => (a.stackingOrder || 0) - (b.stackingOrder || 0))
    .forEach((block, i) => {
      // add i to ensure sequence is kept
      forward[`blocks/${block.board}/${block.id}/stackingOrder`] = order + i
      backward[`blocks/${block.board}/${block.id}/stackingOrder`] =
        block.stackingOrder
    })
  return { forward, backward }
}

export const sendToFront = blocks =>
  firebaseAction((update, { dispatch }) => {
    const { forward, backward } = getOrderActions(
      blocks,
      new Date().valueOf() - 1494110302577
    )
    dispatch({ type: SEND_TO_FRONT, payload: { blocks } })
    update({ forward, backward })
    ReactGA.event({
      category: 'Blocks',
      action: 'Update Block Stacking',
      label: 'Send To Front'
    })
  })

export const sendToBack = blocks =>
  firebaseAction((update, { dispatch }) => {
    const { forward, backward } = getOrderActions(
      blocks,
      1494110302577 - new Date().valueOf()
    )
    dispatch({ type: SEND_TO_BACK, payload: { blocks } })
    update({ forward, backward })
    ReactGA.event({
      category: 'Blocks',
      action: 'Update Block Stacking',
      label: 'Send To Back'
    })
  })

// Grouping

export const group = blocks =>
  firebaseAction((update, { getKey, dispatch }) => {
    const groupId = getKey()

    let forward = {}
    let backward = {}
    blocks.forEach(block => {
      forward[`blocks/${block.board}/${block.id}/group`] = groupId
      backward[`blocks/${block.board}/${block.id}/group`] = null
    })

    dispatch({ type: GROUP, payload: { blocks, groupId } })
    update({ forward, backward })
    ReactGA.event({
      category: 'Blocks',
      action: 'Group Blocks',
      value: blocks.length
    })
  })

export const ungroup = blocks =>
  firebaseAction((update, { dispatch }) => {
    const groupId = blocks[0].group

    let forward = {}
    let backward = {}
    blocks.forEach(block => {
      forward[`blocks/${block.board}/${block.id}/group`] = null
      backward[`blocks/${block.board}/${block.id}/group`] = groupId
    })

    dispatch({ type: UNGROUP, payload: { blocks, groupId } })
    update({ forward, backward })
    ReactGA.event({
      category: 'Blocks',
      action: 'Ungroup Blocks',
      value: blocks.length
    })
  })

// Move / Resize

export const setBlockLayout = blocks =>
  firebaseAction((update, { dispatch }) => {
    let forward = {}
    let backward = {}
    let bottom = 0
    blocks.forEach(({ block, layout }) => {
      Object.keys(layout).forEach(key => {
        if (key === 'top') layout[key] = Math.max(layout[key], 0)
        if (key === 'column') {
          layout[key] = Math.max(layout[key], 0)
          const width = layout.width || block.width // if width is not specified in update, use existing width
          layout[key] = Math.min(layout[key], cols - width)
        }
        forward[`blocks/${block.board}/${block.id}/${key}`] = layout[key]
        backward[`blocks/${block.board}/${block.id}/${key}`] = block[key]
      })
      if (block.image && block.image.cropOverride) {
        Object.keys(block.image.cropOverride).forEach(key => {
          forward[`blocks/${block.board}/${block.id}/image/crop/${key}`] =
            block.image.cropOverride[key]
          const previous = block.image.crop && block.image.crop[key]
          backward[`blocks/${block.board}/${block.id}/image/crop/${key}`] =
            previous === undefined ? null : previous
        })
      }

      const updateBottom = () => {
        const aspect = layout.aspect || block.aspect
        const width = layout.width || block.width
        const height = layout.height || block.height
        const top = layout.top || block.top
        bottom = Math.max((aspect ? aspect * width : height) + top, bottom)
      }
      updateBottom()
    })

    dispatch(
      setSectionMinHeight(
        blocks[0].block.board,
        blocks[0].block.section,
        bottom
      )
    )

    update({ forward, backward })
  })

export const cloneBlocks = blocks =>
  firebaseAction(async (update, { dispatch, getKey }) => {
    if (!blocks) return

    if (dispatch(enforceLimits())) return

    let forward = {}
    let backward = {}
    const select = []
    const newGroups = {}

    blocks
      // .sort((a, b) => (a.stackingOrder || 0) - (b.stackingOrder || 0))
      .forEach(({ block, layout }) => {
        const id = getKey()
        const newBlock = {
          ...block,
          ...layout,
          layout: null,
          id: id,
          dateCreated: timestamp,
          stackingOrder: block.stackingOrder + 1
        }

        if (block.group) {
          if (!(block.group in newGroups)) newGroups[block.group] = getKey()
          newBlock.group = newGroups[block.group]
        }

        select.push(newBlock.group || id)

        const path = `blocks/${newBlock.board}/${id}`
        forward[path] = newBlock
        backward[path] = null

        if (block.image && block.image.pendingUpload) {
          forward[
            `/pendingUploads/${block.image.pendingUpload}/locations/${
              newBlock.id
            }`
          ] = `blocks/${newBlock.board}/${id}`
          backward[
            `/pendingUploads/${block.image.pendingUpload}/locations/${
              newBlock.id
            }`
          ] = null
        }
      })

    update({ forward, backward })
    dispatch({ type: SELECT_BLOCKS, payload: { blocks: select } })

    ReactGA.event({
      category: 'Blocks',
      action: 'Clone Blocks',
      value: blocks.length
    })
  })

// Placement

const enforceLimits = () => (dispatch, getState) => {
  const state = getState()
  if (boardFullSelector(state)) {
    const board = currentBoardSelector(state)
    const userId = userIdSelector(state)
    if (board.owner.id === userId)
      dispatch(
        showAlert(null, i18n.t('alert.blockLimitFull.owner'), undefined, [
          {
            label: i18n.t(['globalNav.createFolder.upgrade', 'upgrade']),
            action: () => dispatch(push('#account-settings/plan'))
          }
        ])
      )
    else dispatch(showAlert(null, i18n.t('alert.blockLimitFull.other')))
    return true
  }
}

export const placeBlock = (block, placement) =>
  firebaseAction((update, { dispatch, getState, getKey }) => {
    if (dispatch(enforceLimits())) return

    const state = getState()
    const auth = state.firebase.auth

    let forward = {}
    let backward = {}

    // Block already exists, and must be in the queue
    const queuedBlock = !!block.id

    if (queuedBlock) {
      const path = `blocks/${placement.section.board}/${block.id}`
      block = {
        ...block,
        board: placement.section.board,
        ...placement,
        section: placement.section.id
      }
      delete block.key // added by react-redux-firebase for ordered items, unwanted in DB

      forward = {
        [`/queues/${auth.uid}/${block.id}`]: null,
        [path]: block
      }
      backward = {
        [`/queues/${auth.uid}/${block.id}`]: block,
        [path]: null
      }

      if (block.image && block.image.pendingUpload) {
        forward[
          `/pendingUploads/${block.image.pendingUpload}/locations/${block.id}`
        ] = path
        backward[
          `/pendingUploads/${block.image.pendingUpload}/locations/${block.id}`
        ] = `/queues/${auth.uid}/${block.id}`
      }
    } else {
      const id = getKey()
      block = {
        ...block,
        board: placement.section.board,
        ...placement,
        section: placement.section.id,
        dateCreated: timestamp,
        id: id,
        owner: auth.uid
      }
      const path = `blocks/${placement.section.board}/${id}`
      forward = {
        [path]: block
      }
      backward = {
        [path]: null
      }

      if (block.image && block.image.pendingUpload) {
        forward[
          `/pendingUploads/${block.image.pendingUpload}/locations/${id}`
        ] = path
        backward[
          `/pendingUploads/${block.image.pendingUpload}/locations/${id}`
        ] = `/queues/${auth.uid}/${id}`
      }
      dispatch(setPlacementMode(null))
    }

    dispatch({ type: PLACE_BLOCK, payload: { block } })
    update({ forward, backward })

    // update queue
    // We do this after everything else so we can be sure the block is placed before previewing the
    // next one otherwise the preview may vanish before the placed block appears causing a flicker
    if (queuedBlock) {
      const queue = getVal(state.firebase, `data/queues/${auth.uid}`)
      const queueLength = Object.keys(queue).length - 1 // subtract one for this placement
      if (queueLength === 0) dispatch(hideToggle('queue')) // hide queue if queue empty
      // if placing the last element, keep the selectedIndex in bounds
      if (queueLength > 0 && queueLength <= state.queue.selectedIndex) {
        dispatch(selectQueueIndex(queueLength - 1))
      }
    }

    let type
    if (block.text) type = 'text'
    if (block.image) type = 'image'
    else type = 'color'
    ReactGA.event({
      category: 'Blocks',
      action: 'Place Block',
      label: type
    })
  })

export const embedBlock = (blockPromise, scroll) =>
  firebaseAction(async (update, { dispatch, getState, getKey }) => {
    if (dispatch(enforceLimits())) return

    let block = await blockPromise

    const state = getState()
    const auth = state.firebase.auth
    const boardId = currentBoardIdSelector(state)
    const boardSize = sizeSelector(state)
    const colWidth = colWidthSelector(state)
    const sections = sectionLayoutSelector(state)

    const width = 10
    const column = (cols - width) / 2 + Math.random()
    const top = (boardSize.height / 3 + scroll) / colWidth + Math.random()

    const section = [...sections.values()]
      .reverse()
      .find(section => section.top <= top)

    let forward = {}
    let backward = {}

    const id = getKey()
    block = {
      board: boardId,
      column,
      dateCreated: timestamp,
      id,
      owner: auth.uid,
      section: section.id,
      stackingOrder: new Date().valueOf() - 1494110302577,
      top: top - section.top,
      type: 'color',
      width,
      ...block
    }

    const path = `blocks/${boardId}/${id}`
    forward[path] = block
    backward[path] = null

    dispatch(setMode('edit'))
    dispatch(setPlacementMode(null))

    dispatch({ type: SELECT_BLOCKS, payload: { blocks: [id] } })
    update({ forward, backward })

    if (block.embed)
      ReactGA.event({
        category: 'Blocks',
        action: 'Embed Block',
        label: block.embed.provider_name
      })
  })

export const pasteBlocks = (scroll, inPlace) =>
  firebaseAction((update, { dispatch, getState, getKey }) => {
    if (dispatch(enforceLimits())) return

    const state = getState()
    const blocks = state.selectedBlocks.copiedBlocks
    if (!blocks) return
    const auth = state.firebase.auth
    const boardId = currentBoardIdSelector(state)
    const boardSize = sizeSelector(state)
    const colWidth = colWidthSelector(state)
    const sections = sectionLayoutSelector(state)

    const layout = Rectangle.combine(blocks.map(b => b.layout))

    const placement = Rectangle.combine(blocks.map(b => b.layout))
    if (!inPlace) {
      placement.x = (cols - placement.width) / 2
      placement.y = (boardSize.height / 3 + scroll) / colWidth + Math.random()
    }

    const section = [...sections.values()]
      .reverse()
      .find(section => section.top <= placement.top)

    let forward = {}
    let backward = {}

    const select = []

    const groups = {}
    blocks
      .sort((a, b) => (a.stackingOrder || 0) - (b.stackingOrder || 0))
      .forEach((block, i) => {
        const delta = layout.getDelta(block.layout)
        const blockLayout = placement.withDelta(delta)

        const id = getKey()
        block = {
          ...block,
          board: boardId,
          column: blockLayout.left,
          top: blockLayout.top - section.top,
          section: section.id,
          dateCreated: timestamp,
          id: id,
          owner: auth.uid,
          layout: null,
          stackingOrder: new Date().valueOf() - 1494110302577 + i
        }

        if (block.group) {
          if (!(block.group in groups)) groups[block.group] = getKey()
          block.group = groups[block.group]
          select.push(block.group)
        } else {
          select.push(id)
        }

        const path = `blocks/${boardId}/${id}`
        forward[path] = block
        backward[path] = null

        if (block.image && block.image.pendingUpload) {
          forward[
            `/pendingUploads/${block.image.pendingUpload}/locations/${id}`
          ] = path
          backward[
            `/pendingUploads/${block.image.pendingUpload}/locations/${id}`
          ] = null
        }
      })

    dispatch(setMode('edit'))
    dispatch(setPlacementMode(null))

    dispatch({ type: SELECT_BLOCKS, payload: { blocks: select } })
    update({ forward, backward })

    ReactGA.event({
      category: 'Blocks',
      action: 'Paste Blocks',
      value: blocks.length
    })
  })

// export const createColorBlock = board => (dispatch, getState, getFirebase) => {
//   const firebase = getFirebase()
//   const state = getState()
//   const auth = state.firebase.auth
//   const id = firebase
//     .database()
//     .ref(`blocks/${board.id}`)
//     .push().key

//   const block = {
//     type: 'color',
//     board: board.id,
//     dateCreated: ServerValue.TIMESTAMP,
//     id: id,
//     name: 'Color',
//     color: '#ccc',
//     owner: auth.uid
//   }
//   dispatch({ type: CREATE_BLOCK, payload: { block } })

//   const path = `/queues/${auth.uid}/${id}`
//   return firebase
//     .database()
//     .ref()
//     .update({
//       [path]: block,
//       // BOLT: ensure lookup and block are consistent
//       // BOLT: ensure lookup is upadted
//       [`blockLookup/${id}`]: path // help find the block (what board is it on or queue?)
//     })
//     .then(() => dispatch(showToggle('queue')))
// }

// export const createTextBlock = (board, text) => (
//   dispatch,
//   getState,
//   getFirebase
// ) => {
//   const firebase = getFirebase()
//   const state = getState()
//   const auth = state.firebase.auth
//   const id = firebase
//     .database()
//     .ref(`blocks/${board.id}`)
//     .push().key

//   let background
//   try {
//     background = new Color(board.backgroundColor || 'white')
//   } catch (e) {
//     background = new Color('white')
//   }
//   const foreground = new Color(background.light() ? 'black' : 'white')

//   const block = {
//     board: board.id,
//     dateCreated: ServerValue.TIMESTAMP,
//     id: id,
//     name: 'Text',
//     text: '',
//     textAlign: 'left',
//     textColor: foreground.toString(),
//     textSize: 0.6,
//     owner: auth.uid
//   }
//   dispatch({ type: CREATE_BLOCK, payload: { block } })

//   const path = `/queues/${auth.uid}/${id}`
//   return firebase
//     .database()
//     .ref()
//     .update({
//       [path]: block,
//       [`blockLookup/${id}`]: path // help find the block (what board is it on or queue?)
//     })
//     .then(() => dispatch(showToggle('queue')))
// }

export const duplicateBlocks = blocks =>
  firebaseAction((update, { dispatch, getState, getKey }) => {
    if (dispatch(enforceLimits())) return

    const state = getState()
    const auth = state.firebase.auth

    let forward = {}
    let backward = {}
    blocks.forEach(block => {
      const id = getKey()
      const path = `/queues/${auth.uid}/${id}`
      forward[path] = {
        ...block,
        id,
        layout: null,
        width: null,
        height: null,
        column: null,
        top: null,
        stackingOrder: null,
        dateCreated: timestamp
      }
      backward[path] = null

      if (block.image && block.image.pendingUpload) {
        forward[
          `/pendingUploads/${block.image.pendingUpload}/locations/${id}`
        ] = path
        backward[
          `/pendingUploads/${block.image.pendingUpload}/locations/${id}`
        ] = null
      }
    })

    dispatch({ type: QUEUE_BLOCKS, payload: { blocks } })
    dispatch(showToggle('queue'))
    update({ forward, backward })
  })

export const queueBlocks = blocks =>
  firebaseAction((update, { dispatch, getState }) => {
    const state = getState()
    const auth = state.firebase.auth

    let forward = {}
    let backward = {}
    blocks.forEach(block => {
      const { board, id } = block
      const path = `blocks/${board}/${id}`
      const queuePath = `/queues/${auth.uid}/${id}`
      forward[queuePath] = {
        // put in queue
        ...block,
        layout: null,
        width: null,
        height: null,
        column: null,
        top: null,
        stackingOrder: null,
        dateCreated: timestamp
      }
      backward[queuePath] = null // remove from queue

      forward[path] = null // remove from board
      backward[path] = block // put back on board
      delete backward[path].layout

      forward[`blockLookup/${id}`] = queuePath // help find the block (what board is it on or queue?)
      backward[`blockLookup/${id}`] = path
    })

    dispatch({ type: QUEUE_BLOCKS, payload: { blocks } })
    dispatch(showToggle('queue'))
    update({ forward, backward })
  })

export const setBlockProperties = (block, properties, options) =>
  firebaseAction((update, { dispatch }) => {
    let forward = {}
    let backward = {}
    Object.keys(properties).forEach(key => {
      if (properties[key] !== block[key]) {
        forward[`blocks/${block.board}/${block.id}/${key}`] = properties[key]
        if (!options || !options.noHistory) {
          backward[`blocks/${block.board}/${block.id}/${key}`] = block[key]
        }
      }
    })

    if (Object.keys(forward).length) {
      dispatch({ type: SET_BLOCK_PROPERTIES, payload: { block, properties } })
      update({ forward, backward })
    }
  })
